import { Button } from '@components/button';
import { FormLabel } from '@components/form-label';
import { IconShare } from '@components/icons/share';
import { Modal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { useClipboard } from '@hooks/use-clipboard';
import { useScopedTranslate } from '@locale/translate';

import { config } from 'app-config';

import { JourneyForm } from 'api/journey-forms/requests';

const FORMS_BASE = config.FORMS_URL;

export const ShareJourneyForm = ({ journeyForm }: { journeyForm: JourneyForm }) => {
  const { t } = useScopedTranslate(locale);
  const { onCopy, copied } = useClipboard();

  return (
    <Modal>
      <Modal.SimpleHeader title={t('shareForm', { name: journeyForm.name })} />
      <Modal.Content>
        <Stack space={4} orientation="horizontal" justify="space-between" align="center">
          <FormLabel text={t('link')} info={t('info', { name: journeyForm.name })} />
          <Button
            variant="secondary"
            iconLeft={<IconShare />}
            text={t(copied ? 'copied' : 'copy')}
            onClick={() => {
              onCopy(
                `${FORMS_BASE}/jf/${journeyForm.journeyUuid}/${journeyForm.uuid}`,
                t('copiedToast')
              );
            }}
          />
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

export const useShareJourneyFormModal = () => useModal(ShareJourneyForm);

export const locale = {
  en: {
    shareForm: 'Share {name}',
    copy: 'Copy link',
    copied: 'Link copied',
    copiedToast: 'Link copied to clipboard',
    link: 'Form submission link',
    info: 'Link to the {name} form',
  },
};
